import { useEffect } from "react";

let idleTimeout: NodeJS.Timeout;

export const useIdleMonitor = (() => {

    useEffect(() => {
        if(idleTimeout) clearTimeout(idleTimeout);
        let idleSeconds = parseInt(process.env.REACT_APP_IDLE_TIMEOUT_SECONDS ?? "300");

        if (process.env.REACT_APP_SHOULD_REDIRECT){
            // Set a new idle timeout to load the base url after idleDurationSecs
            idleTimeout = setTimeout(() => window.location.href = window.location.origin, idleSeconds * 1000);
            console.log("Starting redirect idle timeout for " + idleSeconds + " seconds.");
        } else {
            idleTimeout = setTimeout(() => window.location.reload(), idleSeconds * 1000);
            console.log("Starting refresh idle timeout for " + idleSeconds + " seconds.");
        }
    });
});